"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepare = void 0;
const string_wrapper_1 = require("./string-wrapper");
const fieldTypes = new Set(['string', 'number', 'symbol']);
function prepare(predicate) {
    if (predicate.hasOwnProperty(string_wrapper_1.valueTypeWrapper)) {
        return (t) => t[predicate[string_wrapper_1.valueTypeWrapper]];
    }
    return fieldTypes.has(typeof predicate)
        ? (t) => t[predicate]
        : predicate;
}
exports.prepare = prepare;
